import React, { useState, useEffect } from 'react'
import CustomModal from '../CustomModal/CustomModal'
import useSconti from '../../hooks/useSconti';
import CustomSearch from '../CustomSearch/CustomSearch';
import useCorsi from '../../hooks/useCorsi';
import { Table, Button, Badge, Card } from 'react-bootstrap';
import { alertService } from '../../services/AlertService';
import useMediaQuery from '../../hooks/useMediaQuery';

export default function AssegnaScontoManager({selectedUser, modalStateSconti, onHide}) {
  const isMobile = useMediaQuery('(max-width: 768px)');
  const { loadingStateSconti, createSconto, getScontiByIdUtente, deleteSconto } = useSconti();
  const { getCorsiByParams } = useCorsi();
  const [selectedCourse, setSelectedCourse] = useState(null);
  const [formData, setFormData] = useState({
    sconto: ''
  });
  const [scontiUtente, setScontiUtente] = useState([]);
  const [scontiToDelete, setScontiToDelete] = useState([]);
  const [scontiToAdd, setScontiToAdd] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (selectedUser) {
      loadScontiUtente();
    }
  }, [selectedUser]);

  const loadScontiUtente = async () => {
    setIsLoading(true);
    try {
      const sconti = await getScontiByIdUtente(selectedUser.id_utente);
      setScontiUtente(sconti);
      setScontiToDelete([]);
      setScontiToAdd([]);
    } catch (error) {
      console.error('Errore nel caricamento sconti:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSearch = async (params) => {
    const response = await getCorsiByParams(params);
    return response;
  };

  const handleFormChange = e => {
    const { name, value } = e.target;
    setFormData(prevState => ({ ...prevState, [name]: value }));
  }

  const handleAddSconto = () => {
    if (!selectedCourse || !formData.sconto) return;

    const existingSconto = [...scontiUtente, ...scontiToAdd].find(
      s => s.id_corso === selectedCourse.id_corso
    );

    if (existingSconto) {
      alertService.warn("Esiste già uno sconto per questo corso", {autoClose: true});
      return;
    }

    const newSconto = {
      id_corso: selectedCourse.id_corso,
      nome_corso: selectedCourse.denominazione,
      sconto: Number(formData.sconto).toFixed(2),
      data_inserimento: new Date().toISOString(),
      isNew: true
    };

    setScontiToAdd(prev => [...prev, newSconto]);
    setSelectedCourse(null);
    setFormData({ sconto: '' });
  };

  const handleSave = async () => {

    for (const idSconto of scontiToDelete) {
      await deleteSconto({id_sconto: idSconto});
    }
    
    for (const sconto of scontiToAdd) {
      await createSconto({
        id_utente: selectedUser.id_utente,
        id_corso: sconto.id_corso,
        sconto: sconto.sconto
      });
    }

    onHide();
  }

  const handleDeleteSconto = (sconto) => {
    if (sconto.isNew) {
      setScontiToAdd(prev => prev.filter(s => s.id_corso !== sconto.id_corso));
    } else {
      setScontiToDelete(prev => [...prev, sconto.id_sconto]);
      setScontiUtente(prev => prev.filter(s => s.id_sconto !== sconto.id_sconto));
    }
  };

  const renderScontiList = () => (
    <div className="mt-4">
      <h6 className="mb-3">Sconti assegnati</h6>
      {isLoading ? (
        <div className="text-center py-3">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Caricamento...</span>
          </div>
        </div>
      ) : [...scontiUtente, ...scontiToAdd].length > 0 ? (
        isMobile ? (
          <div className="d-flex flex-column gap-3">
            {[...scontiUtente, ...scontiToAdd].map((sconto) => (
              <Card 
                key={sconto.id_sconto || sconto.id_corso} 
                className={sconto.isNew ? 'border-success bg-success bg-opacity-10' : ''}
              >
                <Card.Body>
                  <div className="d-flex justify-content-between align-items-start mb-2">
                    <div>
                      <h6 className="mb-1">{sconto.nome_corso}</h6>
                      <Badge bg="success" className="me-2">€ {Number(sconto.sconto).toFixed(2)}</Badge>
                    </div>
                    <Button 
                      variant="outline-danger" 
                      size="sm"
                      onClick={() => handleDeleteSconto(sconto)}
                    >
                      <i className="bi bi-trash3"></i>
                    </Button>
                  </div>
                  <small className="text-muted">
                    {new Date(sconto.data_inserimento).toLocaleDateString()}
                  </small>
                </Card.Body>
              </Card>
            ))}
          </div>
        ) : (
          <div className="table-responsive">
            <Table hover className="align-middle mb-0">
              <thead className="table-light">
                <tr>
                  <th style={{width: '40%'}}>Corso</th>
                  <th style={{width: '20%'}}>Importo Sconto</th>
                  <th style={{width: '30%'}}>Data Assegnazione</th>
                  <th style={{width: '10%'}} className="text-end">Azioni</th>
                </tr>
              </thead>
              <tbody>
                {[...scontiUtente, ...scontiToAdd].map((sconto) => (
                  <tr key={sconto.id_sconto || sconto.id_corso} className={sconto.isNew ? 'table-success' : ''}>
                    <td className="text-truncate">{sconto.nome_corso}</td>
                    <td>
                      <Badge bg="success">€ {Number(sconto.sconto).toFixed(2)}</Badge>
                    </td>
                    <td>{new Date(sconto.data_inserimento).toLocaleDateString()}</td>
                    <td className="text-end">
                      <Button 
                        variant="outline-danger" 
                        size="sm"
                        onClick={() => handleDeleteSconto(sconto)}
                      >
                        <i className="bi bi-trash3"></i>
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        )
      ) : (
        <p className="text-muted text-center">Nessuno sconto assegnato</p>
      )}
    </div>
  );

  const renderBody = () => (
    <div className='container-fluid px-0'>
      <div className='row'>
        <div className='col-12 mb-1'>
          <CustomSearch
            field={"denominazione"}
            label={"Cerca corso"}
            searchApi={handleSearch}
            placeholder={"Nome del corso"}
            selectedItem={selectedCourse}
            setSelectedItem={setSelectedCourse}
          />
          {selectedCourse && (
            <div className='mt-2'>
              <span className='small text-muted d-block mb-1'><b>Corso selezionato</b></span>
              <span>{selectedCourse?.denominazione} ({selectedCourse?.codice})</span>
            </div>    
          )}
        </div>
        <div className='col-12 d-flex gap-2'>
          <div className="flex-grow-1">
            <span className='small text-muted d-block mb-1'><b>Importo sconto (€)</b></span>
            <input 
              name="sconto" 
              value={formData.sconto} 
              onChange={handleFormChange} 
              className="form-control" 
              type="number" 
              placeholder="Inserisci l'importo dello sconto"
            />
          </div>
          <div className="align-self-end">
            <Button 
              variant="primary"
              onClick={handleAddSconto}
              disabled={!selectedCourse || !formData.sconto}
            >
              Aggiungi
            </Button>
          </div>
        </div>
      </div>
      {renderScontiList()}
    </div>
  );

  return (
    <CustomModal
      title="Assegna sconto"
      body={renderBody()}
      isLoading={loadingStateSconti.isLoadingScontoCreating || loadingStateSconti.isLoadingScontoDeleting}
      onSave={handleSave}
      onHide={onHide}
      btnText={"Salva"}
      show={modalStateSconti.showModalCreateSconto}
      size="xl"
      onUndoChanges={onHide}
    />
  );
}
